import { ROUTERS_COMMON_DOCUMENT_TITLES, RoutesNameEnum } from '@/constant';
import { MyPageSelectors } from '@/stores/my-page';
import { getTranslatedMessage } from '@/utils';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const KOLLABO_TITLE = '콜라보(KOLLABO)';

const useDocumentTitle = () => {
	const { t } = useTranslation('menu');
	const { pathname } = useLocation();
	const { role } = useSelector(MyPageSelectors.selectDataMyPage);

	const routeCode = useMemo(() => {
		const match = pathname.match(
			/\/(?:system|worker|foreign)(?:\/sub-[^/]+)?\/([a-z]+\d-\d{2})(\/create|\/[^/]+)?$/i
		);

		if (!match) return null;

		const baseCode = match[1];
		const suffix = match[2];

		let result = baseCode?.replace('-', '_')?.toLocaleUpperCase();

		if (suffix === '/create') {
			result = result?.replace('01', '02');
		} else if (suffix) {
			result = result?.replace('01', '03');
		} else {
			return result;
		}

		return result;
	}, [pathname]);

	const documentTitle = useMemo(() => {
		if (!routeCode) return null;

		const routeCodeName = getTranslatedMessage(
			t,
			ROUTERS_COMMON_DOCUMENT_TITLES?.[role]?.[routeCode] || routeCode,
			{ ns: 'menu' }
		);

		return routeCodeName;
	}, [routeCode, t, role]);

	useEffect(() => {
		if (!documentTitle) return;
		document.title = `${documentTitle === RoutesNameEnum.ED1_01 ? '' : `${documentTitle} - `}${KOLLABO_TITLE}`;
	}, [documentTitle]);
};

export default useDocumentTitle;
